import { render, staticRenderFns } from "./detail_management.vue?vue&type=template&id=14e2c2a8&scoped=true&"
import script from "./detail_management.vue?vue&type=script&lang=js&"
export * from "./detail_management.vue?vue&type=script&lang=js&"
import style0 from "./detail_management.vue?vue&type=style&index=0&id=14e2c2a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e2c2a8",
  null
  
)

export default component.exports